


import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Box, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../../components/BaseUrl.js";
import TruncatedCell from "../../../../components/TruncatedCell.js";
import TaskDetails from "./TaskDetails"; // Import the TaskDetails component
import { useTranslation } from "react-i18next";
import {
  convertLocalDateTimeToUTC,
  convertUTCToLocalDateTime,
} from "../../../../components/dateTimeUtils";
import CustomText, { textStyles } from "../../../../components/CustomText";
import {
  getStatusBadgeBackgroundColor,
  getStatusBadgeForegroundColor,
} from "../../../../constants/statusPalette";
const localizer = momentLocalizer(moment);

const ISO_WITHOUT_TIMEZONE_REGEX =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?$/;

const normalizeUTCInput = (value) => {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (ISO_WITHOUT_TIMEZONE_REGEX.test(trimmed)) return `${trimmed}Z`;
  return trimmed;
};

const toCalendarDate = (value) => new Date(normalizeUTCInput(value));

const CalendarTask = ({  onSelectTask, onFilterByDate, selectedTaskId ,  statusFilter,priorityFilter,
  onClearFilter, taskViewTab

}) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null); // To store selected task
  const [showTaskDetails, setShowTaskDetails] = useState(false); // Toggle between calendar and task details
  const [view, setView] = useState("month");
  const {t} = useTranslation();
  const token = useSelector((state) => state.auth.token);
  const { company } = useSelector((state) => state.auth);
  const companyId = company?.id;
  const decryptedToken = token ? decryptToken(token) : null;
// const filteredEvents = useMemo(() => {
//   let result = events;

//   if (statusFilter) {
//     result = result.filter(e => e.status === statusFilter);
//   }

//   if (selectedTaskId) {
//     result = result.filter(e => e.id === selectedTaskId);
//   }

//   return result;
// }, [events, statusFilter, selectedTaskId]);

const filteredEvents = useMemo(() => {
  let result = events;

  if (statusFilter) {
    result = result.filter(e => e.status === statusFilter);
  }

  if (priorityFilter) {
    result = result.filter(e => e.priority === priorityFilter);
  }

  if (selectedTaskId) {
    result = result.filter(e => e.id === selectedTaskId);
  }

  return result;
}, [events, statusFilter, priorityFilter, selectedTaskId]);

const formatLocalTimeRangePart = (dateTimeValue) => {
  if (!dateTimeValue) return "--";
  const formatted = convertUTCToLocalDateTime(dateTimeValue, {
    locale: "en-GB",
    formatOptions: {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    },
  });
  return formatted === "—" ? "--" : formatted;
};

const getTodayDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};


  const fetchTasks = useCallback(async () => {
      setLoading(true);  
    try {
      let url = `${BASE_URL}/task-management/admin/tasks?page=1&page_size=100&show_history=true`;
      if (taskViewTab === "today") {
        const today = getTodayDate();
        const from = convertLocalDateTimeToUTC(`${today}T00:00:00`);
        const to = convertLocalDateTimeToUTC(`${today}T23:59:59`);
        if (from) url += `&from=${encodeURIComponent(from)}`;
        if (to) url += `&to=${encodeURIComponent(to)}`;
      }
      const res = await fetch(
        url,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      const json = await res.json();
      if (!json.error) {
        const mappedEvents = json.data.tasks.map((task) => {
          const workersArray = Array.isArray(task.assigned_workers) ? task.assigned_workers : [];
          const workerNames = workersArray.map((w) => w && w.worker_name).filter(Boolean).join(", ");
          return {
            id: task.id,
            title: task.title,
            start: toCalendarDate(task.start_at),
            end: toCalendarDate(task.end_at),
            startAtRaw: task.start_at,
            endAtRaw: task.end_at,
            status: task.status,
            priority: task.priority,
            worker: workerNames,
            workers: workersArray,
          };
        });
        setEvents(mappedEvents);
      }
    } catch (err) {
      console.error("❌ Error fetching tasks:", err);
    } finally {
      setLoading(false);
    }
  }, [decryptedToken, taskViewTab]);

  useEffect(() => {
    const reload = () => { setLoading(true); fetchTasks(); };
    if (decryptedToken) fetchTasks();
    window.addEventListener("tasks:updated", reload);
    return () => window.removeEventListener("tasks:updated", reload);
  }, [decryptedToken, fetchTasks]);

  // const eventStyleGetter = (event) => {
  // let backgroundColor = "#90caf9"; // default (soft blue)

  // if (event.status === "completed") backgroundColor = "#a5d6a7";   // soft green
  // if (event.status === "assigned") backgroundColor = "#64b5f6";    // light blue
  // if (event.status === "cancelled") backgroundColor = "#ef9a9a";   // soft red
  // if (event.status === "in_progress") backgroundColor = "#ffcc80"; // soft orange
  // if (event.status === "not_done") backgroundColor = "#b0bec5";  
  //   return {
  //     style: {
  //       backgroundColor,
  //       color: "white", // ensures white text
  //       borderRadius: "6px",
  //       border: "0px",
  //       paddingLeft: "4px",
  //     },
  //   };
  // };
const eventStyleGetter = (event) => {
  const statusKey = event.status || "assigned";
  const backgroundColor = getStatusBadgeBackgroundColor(statusKey);
  const color = getStatusBadgeForegroundColor(statusKey);
  const isSelected = event.id === selectedTaskId;

  return {
    style: {
      backgroundColor,
      color,
      borderRadius: "6px",
      border: isSelected ? "3px solid #000" : "0px",
      boxShadow: isSelected ? "0 0 0 2px rgba(0,0,0,0.3)" : "none",
      paddingLeft: "4px",
    },
  };
};
  
  const handleEventClick = (event) => {
    onSelectTask && onSelectTask(event.id);
  };

  const handleBackToCalendar = () => {
    setShowTaskDetails(false);
    setSelectedTask(null);
  };

  // Suppress default time label inside events for grid views; keep it for agenda (Year)
  const formats = useMemo(() => (
    view === "agenda"
      ? {}
      : { eventTimeRangeFormat: () => "" }
  ), [view]);

  const handleNameClick = async (event) => {
    try {
      const firstWorkerId = event.workers?.[0]?.worker_id;
      if (!firstWorkerId || !companyId) return;
      const date = moment(event.start).format("YYYY-MM-DD");
      const res = await fetch(`${BASE_URL}/task-management/admin/tasks/by-date?worker_id=${firstWorkerId}&company_id=${companyId}&date=${date}`, {
        headers: { Authorization: `Bearer ${decryptedToken}` },
      });
      const data = await res.json();
      const tasksForDay = Array.isArray(data?.data?.tasks) ? data.data.tasks : [];
      // Normalize: ensure each list item exposes a top-level id and title
      const normalized = tasksForDay.map((item) => ({
        id: item?.task?.id ?? item?.id,
        title: item?.task?.title ?? item?.title,
        start_at: item?.task?.start_at ?? item?.start_at,
        end_at: item?.task?.end_at ?? item?.end_at,
        raw: item,
      })).filter((t) => !!t.id);

      if (typeof onFilterByDate === "function") {
        onFilterByDate({ date, workerId: firstWorkerId, tasks: normalized });
      }
    } catch (e) {
      console.error("by-date fetch failed", e);
    }
  };

//   const filteredEvents = useMemo(() => {
//   if (!selectedTaskId) return events;
//   return events.filter(e => e.id === selectedTaskId);
// }, [events, selectedTaskId]);

  return (
    <>
    <Box
      sx={{
            position: "relative",   // 👈 REQUIRED

        height: "80vh",
        p: 2,
        background: "#fff",
        borderRadius: "8px",
        overflowY: "auto",
      }}
    >
      <CustomText
        sx={{
          ...textStyles.h1,
          fontSize: 18,
          fontWeight: 600,
          color: "#003149",
          textAlign: "left",
          mb: 2,
        }}
      >
        {t("sidebar.taskManagement")}
      </CustomText>
       {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
        {(selectedTaskId || statusFilter  || priorityFilter) && (
  <Box
    sx={{
      position: "absolute",
      top: 12,
      left: 12,
      zIndex: 10,
      background: "red",
      color:"white",
      borderRadius: "50%",
      width: 28,
      height: 28,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
      fontSize: 18,
      fontWeight: 600
    }}
    // onClick={onClearFilter}
    onClick={() => {
  onClearFilter && onClearFilter();
}}
  >
    ×
  </Box>
)}
            <Calendar
              localizer={localizer}
               events={filteredEvents}

              defaultView="month"
              view={view}
              // views={["day", "week", "month", "agenda"]}
              startAccessor="start"
              endAccessor="end"
              style={{ height: "100%" }}
               eventPropGetter={eventStyleGetter}
              onSelectEvent={handleEventClick}
              onView={(v) => setView(v)}
              length={view === "agenda" ? 365 : undefined}
                         messages={{
  today: t("calendar.today"),
  previous: t("calendar.back"),
  next: t("calendar.next"),
  month: t("calendar.month"),
  week: t("calendar.week"),
  day: t("calendar.day"),
  agenda: t("calendar.year")
}}
              toolbar={true}
              formats={formats}
              components={{
                event: ({ event }) => {
                  const fg = getStatusBadgeForegroundColor(event.status || "assigned");
                  return (
                  <Box>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                      <span
                        onClick={(e) => { e.stopPropagation(); onSelectTask && onSelectTask(event.id); }}
                        style={{ cursor: "pointer", flex: 1 }}
                      >
                        <TruncatedCell text={event.title} sx={{ color: fg, textAlign: "left" }} />
                      </span>
                      <small style={{ whiteSpace: "nowrap", marginLeft: 6, color: fg }}>
                        {formatLocalTimeRangePart(event.startAtRaw || event.start)} - {formatLocalTimeRangePart(event.endAtRaw || event.end)}
                      </small>
                    </Box>
                    {event.worker ? (
                      <Box sx={{ mt: 0.5 }}>
                        <span
                          onClick={(e) => { e.stopPropagation(); handleNameClick(event); }}
                          style={{ cursor: "pointer", opacity: 0.95 }}
                        >
                          <TruncatedCell text={event.worker} sx={{ color: fg, textAlign: "left" }} />
                        </span>
                      </Box>
                    ) : null}
                  </Box>
                  );
                },
          }}
        />
        </>
      )}
    </Box>

    
    </>
  );
};

export default CalendarTask;



